import { tv } from 'tailwind-variants';

export const styles = tv({
  slots: {
    base: 'w-full overflow-hidden transition-[max-height]'
  },
  variants: {
    collapsed: {
      true: {
        base: 'max-h-0'
      }
    },
    withLineClamp: {
      true: {
        base: 'line-clamp-[var(--line-clamp)]'
      }
    }
  }
});
